export default {
    namespaced: true,
    state: {
        pageTitle: 'Sadakhata'
    },
    mutations: {
        SET_PAGE_TITLE (state, pageTitle) {
            state.pageTitle = pageTitle;
        }
    }
};
